import { render, staticRenderFns } from "./ASC_FindingSummaryCombined.vue?vue&type=template&id=3c1958a6&scoped=true&"
import script from "./ASC_FindingSummaryCombined.vue?vue&type=script&lang=js&"
export * from "./ASC_FindingSummaryCombined.vue?vue&type=script&lang=js&"
import style0 from "./ASC_FindingSummaryCombined.vue?vue&type=style&index=0&id=3c1958a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1958a6",
  null
  
)

export default component.exports